import { InformationCircleIcon } from '@heroicons/react/outline';
import { Popover } from '@mantine/core';
import { PopoverProps } from '@mantine/core/lib/Popover/Popover';
import React from 'react';

export interface InformationPopoverProps
  extends React.PropsWithChildren<PopoverProps> {
  target?: React.ReactNode;
}

export const InformationPopover: React.FC<InformationPopoverProps> = (
  props
) => {
  const { target, children, ...rest } = props;
  return (
    <Popover width={300} position="bottom" withArrow shadow="md" {...rest}>
      <Popover.Target>
        <InformationCircleIcon className="ml-2 h-5 w-5 cursor-pointer text-gray-400" />
      </Popover.Target>
      <Popover.Dropdown>{children}</Popover.Dropdown>
    </Popover>
  );
};
